export type { TJournalPageProps } from './types'
export { getSeoData } from './api'

export { SEO_TITLE, SEO_DESCRIPTION } from './constants'
